import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/logisticsManage/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsManage/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsManage/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsManage/img/4.avif';
import image5 from '@src/assets/images/solution/logisticsManage/img/5.avif';
import image6 from '@src/assets/images/solution/logisticsManage/img/6.avif';

export default {
  type: '물류 솔루션',

  banner: {
    title: '복잡한 실내 물류창고의 컨테이너 차량 위치 자동 추적',
    desc: '넓은 물류창고에서 컨테이너 차량의 위치를 실시간으로 파악하고 비어 있는 구역을 즉시 확인할 수 있습니다.',
  },

  video: {
    title: '복잡한 물류창고에서도 차량은 정해진 목적지만 향합니다',
    desc: '컨테이너 차량에 부착된 RTLS 태그와 실내 측위 인프라가 연동되어 위치를 자동으로 식별합니다. 대시보드에는 주차 위치와 차량 흐름이 실시간으로 표시되어 작업자는 혼란 없이 바로 작업에 진입할 수 있습니다.',
    play: mainVideo,
  },

  func: [
    {
      theme: '차량 추적 및 위치 데이터 수집',
      title: '컨테이너 차량 위치 자동 식별',
      desc: '차량마다 부착된 RTLS 태그를 통해 실시간으로 컨테이너의 위치가 자동 식별되며, 위치 좌표는 대시보드에 시각화되어 현재 위치와 상태를 정확하게 파악할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '주차 가능 구역 실시간 표시',
      desc: '시스템은 현재 비어 있는 주차 공간을 자동 분석해 운전자에게 시각적으로 표시합니다. 차량은 안내된 최적 위치로 바로 이동할 수 있어 주차 대기 시간을 단축할 수 있습니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '경로 중복 방지를 위한 동선 시각화',
      desc: '다수의 차량이 동시에 이동할 때 경로 충돌이 발생하지 않도록 예상 동선이 화면에 시각화됩니다. 이를 통해 작업 흐름의 혼잡을 사전에 방지하고, 진입과 회차 경로를 정돈할 수 있습니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      theme: '운영 관리 자동화 및 증빙 활용',
      title: '컨테이너 위치 검색 기능',
      desc: '작업자는 컨테이너 번호 또는 차량 번호를 검색창에 입력해 해당 차량의 현재 위치를 바로 확인할 수 있습니다. 수동 탐색 없이 목적 차량에 빠르게 접근할 수 있어 작업 속도가 개선됩니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: '입출차 기록 및 위치 이력 관리',
      desc: '각 차량의 진입 시점부터 최종 위치까지의 이동 이력을 타임라인으로 저장합니다. 이 정보는 추후 물류 흐름 분석이나 출입 증빙 자료로 활용됩니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '실시간 알림 및 관리자 대시보드 구성',
      desc: '비정상 경로, 장시간 대기, 지정구역 외 주차 등 이상 징후 발생 시 실시간으로 관리자에게 알림이 전송되며, 대시보드에서는 전체 상황을 통합적으로 모니터링할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',
    data: [
      {
        icon: IconBinocularsGray,
        title: '컨테이너 위치 추적',
        desc: '실시간 위치추적 태그로 컨테이너 차량의 위치를 자동 추적하고 시각화합니다.',
      },
      {
        icon: IconClockGray,
        title: '야외 도크 차량 현황 파악',
        desc: 'AI 영상분석으로 야외 도크 구역에 대기 중인 차량 수와 위치를 자동 인식하고 실시간 표시합니다.',
      },
      {
        icon: IconChartBarGray,
        title: '주차 구역 자동 분석',
        desc: '창고 내 비어 있는 주차 공간을 실시간으로 파악하여 최적 구역을 제시합니다.',
      },
      {
        icon: IconSearch,
        title: '컨테이너 번호 검색 기능',
        desc: '검색창에 번호를 입력하면 해당 차량의 현재 위치를 바로 확인할 수 있습니다.',
      },
      {
        icon: IconZoneGray,
        title: '실내지도 기반 위치 확인',
        desc: '건물 내부 지도를 기반으로 각 차량의 위치를 실시간으로 시각적으로 표시해 공간 인식을 돕습니다.',
      },
      {
        icon: IconDashboard,
        title: '실시간 상황판 제공',
        desc: '전체 차량 위치와 주차 상태를 한눈에 볼 수 있는 시각화 인터페이스를 제공합니다.',
      },
      {
        icon: IconRoute,
        title: '이동 동선 시각화',
        desc: '여러 차량의 경로를 예측해 동선 충돌을 방지하고 혼잡도를 줄입니다.',
      },
      {
        icon: IconClockGray,
        title: '입출차 시간 및 위치 저장',
        desc: '차량이 언제, 어디서 들어오고 나갔는지 이력이 자동 저장됩니다.',
      },
      {
        icon: IconChartRadius,
        title: '물류 재고 흐름 리포트',
        desc: '차량 위치 이력과 흐름 데이터를 바탕으로 자동 리포트를 생성하여 운영 분석에 활용됩니다.',
      },
      {
        icon: IconUserCheck,
        title: '위치 기반 작업 효율 개선',
        desc: '작업자는 위치 기반으로 바로 컨테이너를 찾고 작업에 착수할 수 있어 효율이 향상됩니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
